import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Configure Font Awesome
config.autoAddCss = false;

// Import icons from pro-regular-svg-icons (far)
import {
    faBars as farBars,
    faMap as farMap,
    faPlus as farPlus,
    faFilterSlash as farFilterSlash,
    faAnglesUpDown as farAnglesUpDown,
    faAngleUp as farAngleUp,
    faAngleDown as farAngleDown,
    faAngleRight as farAngleRight,
    faEllipsisVertical as farEllipsisVertical,
    faUser as farUser,
    faLocationPin as farLocationPin,
    faLocationDot as farLocationDot,
    faLayerGroup as farLayerGroup,
    faLayerMinus as farLayerMinus,
    faArrowLeft as farArrowLeft,
    faCircle as farCircle,
    faMinus as farMinus,
    faSirenOn as farSirenOn,
    faCheck as farCheck,
    faShield as farShield,
    faComment as farComment,
    faComments as farComments,
    faArrowsUpDownLeftRight as farArrowsUpDownLeftRight,
    faBackwardFast as farBackwardFast,
    faPlay as farPlay,
    faPause as farPause,
    faShieldCheck as farShieldCheck,
    faBolt as farBolt,
    faCloudArrowUp as farCloudArrowUp,
    faRotateLeft as farRotateLeft,
    faArrowRotateLeft as farArrowRotateLeft,
    faCircleDot as farCircleDot,
    faIndent as farIndent,
    faStop as farStop,
    faCircleInfo as farCircleInfo,
    faChevronUp as farChevronUp,
    faChevronDown as farChevronDown,
    faSun as farSun,
    faCrosshairs as farCrosshairs,
    faHouseMedical as farHouseMedical,
    faUserPolice as farUserPolice,
    faUserShield as farUserShield,
    faUserTie as farUserTie,
    faUserHelmetSafety as farUserHelmetSafety,
    faUserHeadset as farUserHeadset,
    faGun as farGun,
    faFire as farFire,
    faSmoke as farSmoke,
    faBurst as farBurst,
    faKitMedical as farKitMedical,
    faFaceFrown as farFaceFrown,
    faCloudBolt as farCloudBolt,
    faTriangleExclamation as farTriangleExclamation,
    faWifiSlash as farWifiSlash,
    faCheckCircle as farCheckCircle,
    faExclamationCircle as farExclamationCircle,
    faTrash as farTrash,
    faTrashCan as farTrashCan,
    faHome as farHome,
    faExternalLink as farExternalLink,
    faArrowUpRightFromSquare as farArrowUpRightFromSquare,
    faExpandWide as farExpandWide,
    faBell as farBell,
    faQuoteLeft as farQuoteLeft,
    faQuoteRight as farQuoteRight,
    faReply as farReply,
    faEnvelope as farEnvelope,
    faArrowRight as farArrowRight,
    faCircleXmark as farCircleXmark,
    faTimes as farTimes,
    faXmark as farXmark,
    faClock as farClock,
    faEyeSlash as farEyeSlash,
    faBug as farBug,
    faBackwardStep as farBackwardStep,
    faBackward as farBackward,
    faStepBackward as farStepBackward,
    faStepForward as farStepForward,
    faForward as farForward,
    faForwardStep as farForwardStep,
    faArrowsRotate as farArrowsRotate,
    faHeartPulse as farHeartPulse,
    faAddressBook as farAddressBook,
    faPhone as farPhone,
    faMessage as farMessage,
    faUsersMedical as farUsersMedical,
    faSpinnerThird as farSpinnerThird,
    faBuilding as farBuilding,
    faQuestionCircle as farQuestionCircle,
    faInfoCircle as farInfoCircle,
    faGrid2 as farGrid2,
    faAnglesLeft as farAnglesLeft,
    faAnglesRight as farAnglesRight,
    faFileLines as farFileLines,
    faSidebar as farSidebar,
    faSidebarFlip as farSidebarFlip,
    faUserPlus as farUserPlus,
    faCrown as farCrown,
    faMapMarkerAlt as farMapMarkerAlt,
    faSearch as farSearch,
    faEdit as farEdit,
    faEllipsisV as farEllipsisV,
    faGlobe as farGlobe,
    faStar as farStar,
    faCog as farCog,
    faSave as farSave,
    faUserCircle as farUserCircle,
    faUsers as farUsers,
    faChevronLeft as farChevronLeft,
    faChevronRight as farChevronRight,
    faCalendar as farCalendar,
    faPenToSquare as farPenToSquare,
    faVectorSquare as farVectorSquare,
    faHandPointer as farHandPointer,
    faLocationPlus as farLocationPlus,
    faEye as farEye,
    faTag as farTag,
    faUserMinus as farUserMinus,
    faHashtag as farHashtag,
    faArrowRightArrowLeft as farArrowRightArrowLeft,
    faMicrochip as farMicrochip,
    faVideoSlash as farVideoSlash,
    faSchool as farSchool,
    faPlug as farPlug,
    faLink as farLink,
    faUnlink as farUnlink,
    faUserPen as farUserPen,
    faCirclePlus as farCirclePlus,
    faRotateRight as farRotateRight,
    faIdBadge as farIdBadge,
    faMobile as farMobile,
    faVenusMars as farVenusMars,
    faCakeCandles as farCakeCandles,
    faRulerVertical as farRulerVertical,
    faBatteryFull as farBatteryFull,
    faBatteryThreeQuarters as farBatteryThreeQuarters,
    faBatteryHalf as farBatteryHalf,
    faBatteryQuarter as farBatteryQuarter,
    faBatteryEmpty as farBatteryEmpty,
} from "@fortawesome/pro-regular-svg-icons";

// Import icons from sharp-light-svg-icons (fasl)
import {
    faIndent as faslIndent,
    faBell as faslBell,
    faMapLocationDot as faslMapLocationDot,
    faRouter as faslRouter,
    faPersonShelter as faslPersonShelter,
    faUsers as faslUsers,
    faGears as faslGears,
    faRightFromBracket as faslRightFromBracket,
    faPlugCircleCheck as faslPlugCircleCheck,
    faTriangleExclamation as faslTriangleExclamation,
    faPlugCircleXmark as faslPlugCircleXmark,
    faPlug as faslPlug,
    faIdBadge as faslIdBadge,
} from "@fortawesome/sharp-light-svg-icons";

// Import icons from sharp-solid-svg-icons (fass)
import {
    faPencil as fassPencil,
    faTrash as fassTrash,
    faMagnifyingGlass as fassMagnifyingGlass,
    faMapLocationDot as fassMapLocationDot,
    faTowerBroadcast as fassTowerBroadcast,
    faVideo as fassVideo,
    faDoorOpen as fassDoorOpen,
    faLock as fassLock,
} from "@fortawesome/sharp-solid-svg-icons";

// Import icons from pro-solid-svg-icons (fas)
import {
    faUser as fasUser,
    faComment as fasComment,
    faComments as fasComments,
    faMap as fasMap,
    faCircleCheck as fasCircleCheck,
    faCircleXmark as fasCircleXmark,
    faTriangleExclamation as fasTriangleExclamation,
    faInfoCircle as fasInfoCircle,
    faBell as fasBell,
    faQuoteLeft as fasQuoteLeft,
    faQuoteRight as fasQuoteRight,
    faLayerGroup as fasLayerGroup,
    faShield as fasShield,
    faEye as fasEye,
    faEyeSlash as fasEyeSlash,
    faPlus as fasPlus,
    faMinus as fasMinus,
    faExpand as fasExpand,
    faCompress as fasCompress,
    faRotateRight as fasRotateRight,
    faRotateLeft as fasRotateLeft,
    faArrowsRotate as fasArrowsRotate,
    faLocationDot as fasLocationDot,
    faLocationCrosshairs as fasLocationCrosshairs,
    faVideo as fasVideo,
    faVideoSlash as fasVideoSlash,
    faKitMedical as fasKitMedical,
    faMicrophone as fasMicrophone,
    faMicrophoneSlash as fasMicrophoneSlash,
    faPhone as fasPhone,
    faPhoneSlash as fasPhoneSlash,
    faShare as fasShare,
    faDownload as fasDownload,
    faUpload as fasUpload,
    faCopy as fasCopy,
    faCheck as fasCheck,
    faTimes as fasTimes,
    faSpinner as fasSpinner,
    faExclamationTriangle as fasExclamationTriangle,
    faSquareQuestion as fasSquareQuestion,
    faSquareCheck as fasSquareCheck,
    faCheckSquare as fasCheckSquare,
    faCircle as fasCircle,
    faBurst as fasBurst,
    faSirenOn as fasSirenOn,
    faMagnifyingGlass as fasMagnifyingGlass,
    faExclamationCircle as fasExclamationCircle,
    faCheckCircle as fasCheckCircle,
    faCircleNotch as fasCircleNotch,
    faSatelliteDish as fasSatelliteDish,
    faInbox as fasInbox,
    faMapMarkerAlt as fasMapMarkerAlt,
    faWifi as fasWifi,
    faHandPointer as fasHandPointer,
    faServer as fasServer,
    faIdBadge as fasIdBadge,
    faUsers as fasUsers,
} from "@fortawesome/pro-solid-svg-icons";

// Add all icons to the library
library.add(
    // Regular (far)
    farBars,
    farMap,
    farPlus,
    farFilterSlash,
    farAnglesUpDown,
    farAngleUp,
    farAngleDown,
    farAngleRight,
    farEllipsisVertical,
    farUser,
    farLocationPin,
    farLocationDot,
    farArrowLeft,
    farCircle,
    farLayerGroup,
    farLayerMinus,
    farMinus,
    farSirenOn,
    farCheck,
    farShield,
    farComment,
    farComments,
    farArrowsUpDownLeftRight,
    farBackwardFast,
    farPlay,
    farPause,
    farShieldCheck,
    farBolt,
    farCloudArrowUp,
    farRotateLeft,
    farArrowRotateLeft,
    farCircleDot,
    farIndent,
    farStop,
    farCircleInfo,
    farChevronUp,
    farChevronDown,
    farSun,
    farCrosshairs,
    farHouseMedical,
    farUserPolice,
    farUserShield,
    farUserTie,
    farUserHelmetSafety,
    farUserHeadset,
    farGun,
    farFire,
    farSmoke,
    farBurst,
    farKitMedical,
    farFaceFrown,
    farCloudBolt,
    farTriangleExclamation,
    farWifiSlash,
    farCheckCircle,
    farExclamationCircle,
    farTrash,
    farTrashCan,
    farHome,
    farExternalLink,
    farArrowUpRightFromSquare,
    farExpandWide,
    farBell,
    farQuoteLeft,
    farQuoteRight,
    farReply,
    farEnvelope,
    farArrowRight,
    farCircleXmark,
    farTimes,
    farXmark,
    farClock,
    farEyeSlash,
    farBug,
    farBackwardStep,
    farBackward,
    farStepBackward,
    farStepForward,
    farForward,
    farForwardStep,
    farArrowsRotate,
    farHeartPulse,
    farAddressBook,
    farPhone,
    farMessage,
    farUsersMedical,
    farSpinnerThird,
    farBuilding,
    farQuestionCircle,
    farInfoCircle,
    farGrid2,
    farAnglesLeft,
    farAnglesRight,
    farFileLines,
    farSidebar,
    farSidebarFlip,
    farUserPlus,
    farCrown,
    farMapMarkerAlt,
    farSearch,
    farEdit,
    farEllipsisV,
    farGlobe,
    farStar,
    farCog,
    farSave,
    farUserCircle,
    farUsers,
    farChevronLeft,
    farChevronRight,
    farCalendar,
    farPenToSquare,
    farVectorSquare,
    farHandPointer,
    farLocationPlus,
    farEye,
    farTag,
    farUserMinus,
    farHashtag,
    farArrowRightArrowLeft,
    farMicrochip,
    farVideoSlash,
    farSchool,
    farPlug,
    farLink,
    farUnlink,
    farUserPen,
    farCirclePlus,
    farRotateRight,
    farIdBadge,
    farMobile,
    farVenusMars,
    farCakeCandles,
    farRulerVertical,
    farBatteryFull,
    farBatteryThreeQuarters,
    farBatteryHalf,
    farBatteryQuarter,
    farBatteryEmpty,

    // Sharp Light (fasl)
    faslIndent,
    faslBell,
    faslMapLocationDot,
    faslRouter,
    faslPersonShelter,
    faslUsers,
    faslGears,
    faslRightFromBracket,
    faslPlugCircleCheck,
    faslTriangleExclamation,
    faslPlugCircleXmark,
    faslPlug,
    faslIdBadge,

    // Sharp Solid (fass)
    fassPencil,
    fassTrash,
    fassMagnifyingGlass,
    fassMapLocationDot,
    fassTowerBroadcast,
    fassVideo,
    fassDoorOpen,
    fassLock,

    // Solid (fas)
    fasUser,
    fasComment,
    fasComments,
    fasMap,
    fasCircleCheck,
    fasCircleXmark,
    fasTriangleExclamation,
    fasInfoCircle,
    fasBell,
    fasQuoteLeft,
    fasQuoteRight,
    fasLayerGroup,
    fasShield,
    fasEye,
    fasEyeSlash,
    fasPlus,
    fasMinus,
    fasExpand,
    fasCompress,
    fasRotateRight,
    fasRotateLeft,
    fasArrowsRotate,
    fasLocationDot,
    fasLocationCrosshairs,
    fasVideo,
    fasVideoSlash,
    fasMicrophone,
    fasMicrophoneSlash,
    fasPhone,
    fasPhoneSlash,
    fasShare,
    fasDownload,
    fasUpload,
    fasCopy,
    fasCheck,
    fasTimes,
    fasSpinner,
    fasExclamationTriangle,
    fasSquareQuestion,
    fasSquareCheck,
    fasCheckSquare,
    fasCircle,
    fasBurst,
    fasSirenOn,
    fasMagnifyingGlass,
    fasExclamationCircle,
    fasCheckCircle,
    fasKitMedical,
    fasCircleNotch,
    fasSatelliteDish,
    fasInbox,
    fasMapMarkerAlt,
    fasWifi,
    fasHandPointer,
    fasServer,
    fasIdBadge,
    fasUsers,
);

export default {
    install (app) {
        // Register the FontAwesome component globally
        app.component("FontAwesomeIcon", FontAwesomeIcon);

        // Watch for DOM changes and replace icons
        dom.watch();
    },
};
